export default __webpack_public_path__ + "static/media/product5.79e0b9b0.png";